/* ============================================================
   Zina Tahiri — Replace "Etsy" mentions in Judge.me reviews
   with neutral phrasing (DRAFT THEME ONLY — does not alter
   actual review data, only the displayed text)
   ============================================================ */
(function () {
  'use strict';

  // Replacement rules — order matters (most specific first).
  // Only replaces "Etsy" when it clearly refers to the platform.
  var rules = [
    { pattern: /\bfound (?:it |this )?on Etsy\b/gi, replacement: function (m) { return m.replace(/on Etsy/i, 'online'); } },
    { pattern: /\bon Etsy\b/gi, replacement: 'online' },
    { pattern: /\bEtsy seller\b/gi, replacement: 'seller' },
    { pattern: /\bEtsy shop\b/gi, replacement: 'shop' },
    { pattern: /\bEtsy store\b/gi, replacement: 'store' },
  ];

  // Standalone "Etsy" fallback — only when clearly a platform reference.
  // We skip all-caps or cases that look like part of a factual statement.
  function replaceStandalone(text) {
    return text.replace(/\bEtsy\b/g, function (match, offset, str) {
      // Skip if preceded by words suggesting a factual/platform statement
      var before = str.slice(Math.max(0, offset - 30), offset).toLowerCase();
      if (/etsy's (terms|policy|platform|website|app)/.test(before + match.toLowerCase())) {
        return match; // leave unchanged
      }
      return 'this shop';
    });
  }

  function replaceEtsy(text) {
    var result = text;
    rules.forEach(function (rule) {
      if (typeof rule.replacement === 'function') {
        result = result.replace(rule.pattern, rule.replacement);
      } else {
        result = result.replace(rule.pattern, rule.replacement);
      }
    });
    result = replaceStandalone(result);
    result = result.replace(/\s{2,}/g, ' ');
    return result;
  }

  function processAuthorNames() {
    // Scan entire Judge.me widget containers for "Inactive Etsy Member"
    // (aggressive: checks all text nodes, not just author-specific classes)
    var containers = document.querySelectorAll(
      '#judgeme_product_reviews, .jdgm-widget, .jdgm-rev-widg, [data-zt-reviews-root]'
    );
    // Fallback: if no widget container found, scan review-related elements
    if (!containers.length) {
      containers = document.querySelectorAll('.jdgm-rev, .jdgm-review');
    }
    containers.forEach(function (container) {
      var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(function (node) {
        // Skip already-processed nodes
        if (node._ztAuthorDone) return;
        if (/Inactive\s+Etsy\s+Member/i.test(node.textContent)) {
          node.textContent = node.textContent.replace(/Inactive\s+Etsy\s+Member/gi, 'Customer');
          node._ztAuthorDone = true;
        }
      });
    });
  }

  function processReviews() {
    processAuthorNames();
    // Judge.me review body elements (covers widget + custom review UI)
    var selectors = '.jdgm-rev__body, .jdgm-rev__body p, .jdgm-review__body';
    var els = document.querySelectorAll(selectors);
    els.forEach(function (el) {
      // Skip if already processed
      if (el.hasAttribute('data-zt-etsy-done')) return;
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      var changed = false;
      nodes.forEach(function (node) {
        if (/\bEtsy\b/i.test(node.textContent)) {
          var newText = replaceEtsy(node.textContent);
          if (newText !== node.textContent) {
            node.textContent = newText;
            changed = true;
          }
        }
      });
      if (changed) el.setAttribute('data-zt-etsy-done', 'true');
    });
  }

  function init() {
    processReviews();
    // Re-run for lazy-loaded / paginated reviews
    setTimeout(processReviews, 2000);
    setTimeout(processReviews, 5000);

    var observer = new MutationObserver(function (mutations) {
      var found = false;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) { found = true; break; }
      }
      if (found) processReviews();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
